import { PageTypes } from '@/config/constant';

export default {
  id: PageTypes.Login,
  path: '/login',
  name: '登录页',
  isNav: false,
  sort: 1,
};
